import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }

  const token = window.localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

const loginService = {
  login(credentials) {

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    const params = new URLSearchParams();
    params.append('username', credentials.username);
    params.append('password', credentials.password);
    params.append('grant_type', 'password');

    return new Promise((resolve, reject) => {
      axios
        .post('/api/token', params, config)
        .then(response => {
          let result = response.data;
          return result;
        })
        .then(async function(result){
          const autorize = {
            headers: {
              'Authorization': `bearer ${result.access_token}`
            }
          }              
          let getOperador = await axios.get('/api/login/operador/'+credentials.username+'?random=' + Math.random(), autorize);
          
          let mergeResult = Object.assign({}, result, getOperador.data);
          //console.log(mergeResult);
          resolve(mergeResult);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOperator(login){

    return new Promise((resolve, reject) => {
      axios.get('/api/login/operador/'+login+'?random=' + Math.random())
            .then(response => {
              //console.log('service ' + response);
              resolve(response);
          })
            .catch(response => {
              reject(response);
          });
      });
  },
};

export default loginService;